import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.css';
import commonStyles from '@styles/common.module.css';

import Scroll from '@components/common/scroll/index';

class ScrollBlock extends Component {
  constructor(props) {
    super(props);

    this.onWheel = this.onWheel.bind(this);
    this.size = 100;
    this.outerRef = React.createRef();
    this.innerRef = React.createRef();
    this.state = { pos: 0, disabled: true };
  }

  onChange(pos) {
    this.setState({ pos });
  }

  updateSize() {
    const outer = this.outerRef.current.clientHeight;
    const inner = this.innerRef.current.clientHeight;

    if (outer < inner) {
      this.size = (100 * outer) / inner;
      if (this.state.disabled || this.size !== this.state.size) {
        this.setState({ disabled: false, size: this.size });
      }
    } else if (!this.state.disabled) {
      this.setState({ disabled: true });
    }
  }

  componentDidMount() {
    this.updateSize();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.children !== this.props.children) {
      const oldSize = this.size;
      const oldPos = this.state.pos;
      this.updateSize();
      if (this.props.disableAutoScrollTop) {
        if (this.size < 100) {
          this.onChange(oldPos * (100 / oldSize - 1) / (100 / this.size - 1));
        } else {
          this.onChange(0);
        }
      } else {
        this.onChange(0);
      }
    }
  }

  onWheel(event) {
    const delta = event.deltaY > 0 ? 1 / (100 / this.size - 1) : 1 / (1 - 100 / this.size);

    if (
      this.state.disabled ||
      (this.state.pos === 0 && delta < 0) ||
      (this.state.pos === 100 && delta > 0)
    ) {
      return;
    }
    event.preventDefault();

    let pos = this.state.pos + delta * 10;

    if (pos > 100) {
      pos = 100;
    } else if (pos < 0) {
      pos = 0;
    }

    this.setState({ pos });
  }

  render() {
    const { children, className, light, lightBackground, wide } = this.props;
    const { disabled, size, pos } = this.state;
    const outer = this.outerRef.current
      ? this.outerRef.current.clientHeight
      : 0;
    const inner = this.innerRef.current
      ? this.innerRef.current.clientHeight
      : 0;
    const top = -(pos / 100) * (inner - outer);

    return (
      <div
        onWheel={this.onWheel}
        className={`${styles.container} ${className} ${
          light ? styles.light : ''
        }`}>
        <div
          ref={this.outerRef}
          className={`${styles.content} ${commonStyles.font} ${
            lightBackground ? styles.white : ''
          }`}>
          <div
            className={`${styles.contentInner} ${
              wide ? styles.contentInnerWide : ''
            }`}
            ref={this.innerRef}
            style={{ top: `${top}px` }}>
            {children}
          </div>
        </div>
        <Scroll
          size={size < 4 ? 4 : size}
          disabled={disabled}
          className={styles.scroll}
          onChange={this.onChange.bind(this)}
          pos={this.state.pos}
          orientation={Scroll.ORIENTATION.VERTICAL}
          light={light}
        />
      </div>
    );
  }
}

ScrollBlock.defaultProps = {
  children: '',
  className: '',
  light: false,
  lightBackground: false,
  wide: false,
  disableAutoScrollTop: false
};

ScrollBlock.propTypes = {
  children: PropTypes.any,
  disableAutoScrollTop: PropTypes.bool
};

export default ScrollBlock;
